export const PlaceEmpty = (user) => {
  const { id = '', name = '', sex = '', avatar = '' } = user;
  return {
    title: 'Place 1',
    lat: '',
    lng: '',
    address: '',
    user: {
      id: id.toString(),
      name,
      sex,
      avatar,
    },
    created: 0,
    images: [],
    imgids: '',
    videos: [],
    map_zoom: 0,
    map_type: '',
    link: '',
    description: '',
    rating: 0,
    url: '',
    access: 5,
    share_key: '',
    bookmark: false,
  };
};
